<!-- PriceSlabsTabs.vue -->
<template>
  <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
    <!-- Uniform Tab -->
    <el-tab-pane label="Uniform" name="uniform">
      <div class="mt-3">
        <el-form :inline="true">
          <el-row type="flex" :gutter="20">
            <el-col :span="11">
              <el-form-item label="No of Steps" class="w-100">
                <span slot="label">
                  No of Steps
                  <span class="required" v-if="activeName === 'uniform'">*</span>
                </span>
                <el-input
                  class="w-100"
                  v-model.number="uniform.steps"
                  type="number"
                  :min="1"
                  :max="20"
                  @blur="validateSteps"
                />
                <p v-if="stepError" style="color: red; font-size: 14px">
                  {{ stepError }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="Step Interval (min)" class="w-100">
                <span slot="label">
                  Step Interval (min)
                  <span class="required" v-if="activeName === 'uniform'">*</span>
                </span>
                <el-input
                  v-model.number="uniform.interval"
                  type="number"
                  @blur="validateInterval"
                />
                <p v-if="intervalError" style="color: red; font-size: 14px">
                  {{ intervalError }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <label
                  class="field-title-label d-block w-100 text-lightGray text-xs !mt-[4px] 2xl:!text-sm font-normal !mb-1"
                >
                  &nbsp;
                </label>

                <el-button
                  type="primary"
                  style="background: var(--brand-500) !important"
                  class="!px[15px] !py-[9px]"
                  @click="generateUniformSlabs"
                >
                  Generate
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-table
          v-if="uniform.slabs.length"
          :data="uniform.slabs"
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="From" prop="from" />
          <el-table-column label="To" prop="to" />
          <el-table-column label="Price">
            <template slot="header">
              Price
              <span class="required">*</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.price" type="number" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>

    <!-- Non-Uniform Tab -->
    <el-tab-pane label="Non-Uniform" name="nonUniform" class="pt-3 mb-1">
      <el-button
        type="primary"
        style="background: var(--brand-500) !important"
        class="!px[15px] !py-[9px]"
        @click="addNonUniformSlab"
      >
        Add Slab
      </el-button>

      <el-table
        v-if="nonUniform?.slabs.length"
        :data="nonUniform.slabs"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column label="From">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.from" type="number" />
          </template>
        </el-table-column>
        <el-table-column label="To">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.to" type="number" />
          </template>
        </el-table-column>
        <el-table-column label="Price">
          <template slot="header">
            Price
            <span class="required">*</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.price" type="number" />
          </template>
        </el-table-column>
        <el-table-column label="Actions">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="removeNonUniformSlab(scope.$index)"
            />
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  export default {
    props: ['data', 'form', 'field'],
    name: 'PriceSlabsTabs',
    data() {
      return {
        activeName: 'uniform',
        uniform: {
          steps: null,
          interval: null,
          slabs: [],
        },
        nonUniform: {
          slabs: [],
        },
        stepError: '',
        intervalError: '',
      };
    },
    mounted() {
      if (
        this.form &&
        this.data?.key &&
        this.form[this.data?.key + '/isSlabConfig'] &&
        this.form[this.data?.key + '/slabConfig']
      ) {
        //pricing_slabs = this.form[this.data.key + "/slabConfig"].slab_prices;
        //isUniform = this.form[this.data.key + "/slabConfig"].isUniform;
        this.activeName = this.form[this.data.key + '/slabConfig'].activeName;
        this.uniform.steps = this.form[this.data.key + '/slabConfig'].steps;
        this.uniform.interval = this.form[this.data.key + '/slabConfig'].interval;
        this.uniform.slabs = this.form[this.data.key + '/slabConfig'].slab_prices;
        this.nonUniform.slabs = this.form[this.data.key + '/slabConfig'].slab_prices;
      } else {
        this.activeName = this.field?.price_settings?.activeName || 'uniform';
        this.uniform.steps = this.field?.price_settings?.maxSteps || null;
        this.uniform.interval = this.field?.price_settings?.intervalMin || null;
        if (this.field?.price_settings?.isUniform) {
          this.uniform.slabs = this.field?.price_settings?.pricingSlabs || [];
        } else {
          this.nonUniform.slabs = this.field?.price_settings?.pricingSlabs || [];
        }
      }
    },
    methods: {
      handleClick(tab) {
        this.activeName = tab.name;
        if (this.field) {
          this.field.price_settings.activeName = tab.name;
          this.field.price_settings.isUniform = tab.name === 'uniform';
          this.field.price_settings.pricingSlabs =
            tab.name === 'uniform' ? [...this.uniform.slabs] : [...this.nonUniform.slabs];
        }
      },
      generateUniformSlabs() {
        this.validateSteps();
        this.validateInterval();
        const { steps, interval } = this.uniform;
        if (!steps || !interval || steps <= 0 || interval <= 0) {
          this.$message.error('Steps and interval must be positive numbers.');
          return;
        }

        const indexes = [...Array(steps).keys()]; // creates [0, 1, 2, ..., steps-1]
        this.uniform.slabs = indexes.map((i) => ({
          from: i * interval,
          to: (i + 1) * interval,
          price: null,
        }));
        this.field.price_settings = {
          ...this.field?.price_settings,
          maxSteps: steps,
          intervalMin: interval,
          isUniform: true,
          activeName: 'uniform',
          pricingSlabs: [...this.uniform.slabs],
        };
      },
      validateSteps() {
        if (this.uniform.steps < 1) {
          this.stepError = 'Steps must be at least 1.';
        } else if (this.uniform.steps > 20) {
          this.stepError = 'Steps cannot exceed 20.';
        } else {
          this.stepError = '';
        }
      },
      validateInterval() {
        if (this.uniform.interval < 2) {
          this.intervalError = 'Interval must be at least 2 minutes.';
          this.uniform.interval = 2;
        } else {
          this.intervalError = '';
        }
      },
      addNonUniformSlab() {
        //this.nonUniform.slabs.push({ from: null, to: null, price: null });
        let newFrom = 0;
        const slabs = this.nonUniform.slabs;

        if (slabs.length > 0) {
          const lastSlab = slabs[slabs.length - 1];
          if (lastSlab.to !== null && !isNaN(lastSlab.to)) {
            newFrom = Number(lastSlab.to);
          } else {
            // If 'to' is not filled in, we keep the new slab's from as null to avoid incorrect range
            newFrom = null;
          }
        }

        slabs.push({ from: newFrom, to: null, price: null });
        this.updateNonUniformSlabs();
      },
      removeNonUniformSlab(index) {
        this.nonUniform.slabs.splice(index, 1);
        this.updateNonUniformSlabs();
      },
      updateNonUniformSlabs() {
        this.field.price_settings.isUniform = false;
        this.field.price_settings.activeName = 'nonUniform';
        this.field.price_settings.maxSteps = null;
        this.field.price_settings.intervalMin = null;
        this.field.price_settings.pricingSlabs = [...this.nonUniform.slabs];
      },
    },
  };
</script>

<style scoped>
  .required {
    color: red;
    font-size: 14px;
  }
</style>
